
import Previewer from 'vux/src/components/previewer/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import {fetchUser, fetchOrderStatus, fetchCustomerService, authLogout} from '@/api/user'
import {delCookie} from '@/utils/index'
import Fly from 'flyio/dist/npm/fly'

export default {
name: 'IndexFooter',
data () {
return {
userInfo: {},
orderStatus: {},
dataArray: [],
customerService: {},
qrImages: []
}
},
components: {
Previewer,
Tabbar,
TabbarItem,
Flexbox,
FlexboxItem,
Confirm
},
methods: {
getUserInfo () {
fetchUser().then(resp => {
this.userInfo = resp.data
})
},
logout () {
authLogout().then(res => {
delCookie('token')
this.$router.push('/')
})
},
contactService (phoneNum) {
console.log(phoneNum)
window.location.href = `tel:${phoneNum}`
},
openQrcode (index) {
this.$refs.previewer.show(index)
},
jumpToOrder (tab) {
this.$router.push(`/order?tab=${tab}`)
},
myConsultant () {
if (this.dataArray==='') {
console.log(1)
let fly = new Fly() 

fly.request('https://api.ruan.net/api/personal/customer_service', {}, {
method: 'get'
}).then(resp => {
console.log(resp,123)
if (resp.data.status === 200) {
this.showCardIndex = 1
this.dataArray = resp.data.data
sessionStorage.setItem('objArr', JSON.stringify(resp.data.data))
}
}).catch((e) => console.log('error', e))
} else {
this.dataArray = JSON.parse(sessionStorage.getItem('objArr'))
}
}
},
created () {
this.dataArray = JSON.parse(sessionStorage.getItem('objArr'))?JSON.parse(sessionStorage.getItem('objArr')):''
this.myConsultant()
},
mounted () {
this.getUserInfo()
fetchOrderStatus().then(resp => {
this.orderStatus = resp.data
})
fetchCustomerService().then(resp => {
this.customerService = resp.data
console.log(this.customerService.wechat_qrcode)
this.qrImages = [
{
thumb: 'https://static.xinmeibao.com/assets_mobile/v1/icon-qcode2.png',
src: this.customerService.wechat_qrcode,
caption: '', // Optional
srcset: '' 
}
]
})
}
}



// WEBPACK FOOTER //
// ./src/pages/me/index.vue